import {
	ChangeDetectionStrategy,
	Component,
	inject,
	signal,
} from "@angular/core"
import { StoreService } from "./services/store.service"
import { BtnExtComponent } from "./utils/utils.component"
import { COMMON_IMPORTS } from "./common-imports"
import { ApiService, senderFactory } from "./services/api.service"
import { ModalService } from "./services/modal.service"
import { ModalWrapComponent } from "./modal-wrap/modal-wrap.component"
import { ConfirmComponent } from "./confirm/confirm.component"
import { OtpComponent } from "./otp/otp.component"
import { LangValPipe } from "./utils/lang-val.pipe"

@Component({
	selector: "backup-btn",
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (!status && !isSent()) {
			<app-btn-ext
				text="request_export"
				class="backup-btn"
				(clickEv)="modalProps.set({ name: 'confirm' })"
				[isSpin]="backupSender.isLoading() || otpSender.isLoading()"
			/>
		}
		@if (status === "completed") {
			<app-btn-ext
				text="download_ready"
				(clickEv)="download.run()"
				[isSpin]="download.isLoading()"
			/>
		}

		@switch (modalProps()?.name) {
			@case ("confirm") {
				<app-modal-wrap
					(onClose)="modalProps.set(null)"
					title="export"
					modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
				>
					<app-confirm
						(onClose)="modalProps.set(null); $event && otpSender.run()"
						[freeText]="
							'
						<p>
בלחיצה על הכפתור <b>בקשה לגיבוי</b>, יישלח קוד אימות חד-פעמי לצורך וידוא זהותך.
</p>
<p>
לאחר שיוזן הקוד, המערכת תכין את קובץ היצוא -
<b>
תהליך זה עלול לקחת מספר שעות.
</b>
</p>
<p>
בסיומו, תהיה אפשרות להורדת הגיבוי.
</p>


						' | langVal
						"
					/>
				</app-modal-wrap>
			}
			@case ("otp") {
				<app-modal-wrap
					(onClose)="modalProps.set(null)"
					title="otp"
					modalWrapperClass="modal-fit-content"
				>
					<app-otp
						(onClose)="modalProps.set(null); $event && backupSender.run()"
					/>
				</app-modal-wrap>
			}
		}
	`,
	imports: [
		COMMON_IMPORTS,
		BtnExtComponent,
		ModalWrapComponent,
		ConfirmComponent,
		OtpComponent,
		LangValPipe,
	],
})
export class BackupBtn {
	storeService = inject(StoreService)
	apiService = inject(ApiService)
	modalService = inject(ModalService)

	status = this.storeService.cc()?.backup_status

	isSent = signal(false)
	modalProps = signal<any>(null)

	download = senderFactory({
		fn: () => this.apiService.download("download_backup"),
		onFinish: ({ result }) =>
			this.apiService.downloadFile(result, `exports.zip`),
	})
	backupSender = senderFactory({
		fn: () => this.apiService.post("request_backup"),
		onFinish: () => {
			this.modalService.openToast("export_request_accepted")
			this.isSent.set(true)
			this.storeService.updateCc({ backup_status: "requested" })
		},
	})
	otpSender = senderFactory({
		fn: () => this.apiService.post("backup_otp"),
		onFinish: () => this.modalProps.set({ name: "otp" }),
	})
}
